import { Injectable, Injector } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from '../auth/app.config';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';

@Injectable()
export class AppConfigService {

    public env: any;
    public appconfig: any;

    constructor(private readonly httpHandler: HttpBackend, private http: HttpClient, private injector: Injector) {
        this.http = new HttpClient(httpHandler);
     }

    public load() {
        return new Promise<boolean>((resolve, reject) => {
          this.http.get('config/config.json').map(res => res)
            .subscribe(configResponse => {
              this.env = configResponse
              // this.appconfig = configResponse
              this.appconfig = this.injector.get(AppConfig);
              resolve(true);
            },
              // (error) => {  //block is Working
              // console.error(error)
              //   reject(error);
              // });
              (error) => {
                console.error(error)
                return Observable.throw(error.json().error || 'Error reading Appsetting');
              });
        });
    
      }

    // public load() {
    //     // return new Promise((resolve, reject) => {
    //     //     this.http.get('config/config.json')
    //     //         .map(res => res).catch((error: any) => {
    //     //             return Observable.throw(error);
    //     //         }).subscribe((configResponse: any) => {
    //     //             this.env = configResponse;
    //     //             resolve('success');
    //     //         }, err => {
    //     //             reject("Could not load the config file");
    //     //         })
    //     // });
    //     return new Promise((resolve, reject) => {

    //         this.http.get('config/config.json')
    //             .map(res => res).catch((error: any) => {
    //                 return Observable.throw(error);
    //             }).subscribe((configResponse: any) => {
    //                 this.env = configResponse;
    //                 this.appconfig = configResponse;

    //                 // this.appconfig = this.injector.get(this.AppConfig);
    //                 // this.appconfig.load().then(
    //                 //     res => {
    //                 //         resolve(true);

    //                 //     }, error => {
    //                 //         reject(false);
    //                 //     }
    //                 // ).catch()


    //             });
    //     })
    // }

    public getEnvironment() {
        return this.env;
    }    
    getSettings(key?: string | Array<string>): any {
        if (!key || (Array.isArray(key) && !key[0])) {
            return this.env;
        }

        if (!Array.isArray(key)) {
            key = key.split('.');
        }

        let result = key.reduce((acc: any, current: string) => acc && acc[current], this.env);

        return result;
    }
}

